import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as EbutlerIcon } from "./live-chat-svgrepo-com.svg";
import Iframe from "react-iframe";
import Draggable from "react-draggable";


const EbutlerWidget = () => {
  const language = useSelector((state) => state.store.language);
  const enable_ebutler = useSelector(
    (state) => state.store.store.settings.enable_ebutler_widget
  );
  const ebutler_company_id = useSelector(
    (state) => state.store.store.settings.link_ebutler
  );
  const enable_ebutler_staff = useSelector(
    (state) => state.store.store.settings.enable_ebutler_widget_staff
  );
  let hideTimeout;

  const [shouldShow, setShouldShow] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [hideChat, setHideChat] = useState(false);
  const [dragging, setDragging] = useState(false);
  const ios =
    !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

  useEffect(() => {
    setTimeout(() => {
      setShouldShow(true);
    }, 50);

    

    if (!hideChat) {
      hideTimeout = setTimeout(() => {
        setShowChat(false);
        setHideChat(false);
      }, 60000);
    }
    return () => {
      clearTimeout(hideTimeout);
    };
  }, [hideChat, showChat]);

   const handleLinkClick = () => {
     if (showChat) {
       setHideChat((prevState) => !hideChat);
     } else {
       setShowChat(true);
       setHideChat(true);
     }
   };

   const onDrag = () => {
     if (!dragging) setDragging(true);
   };

   const onStop = () => {
     setDragging(false);
     if (!dragging) {
       handleLinkClick();
     }
   };

  if (!enable_ebutler || !ebutler_company_id || !enable_ebutler_staff)
    return null;

  return shouldShow ? (
    <>
      <span
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          zIndex: "1500",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: hideChat ? "block" : "none",
        }}
        onClick={() => {
          setHideChat(false);
        }}
      />
      <Draggable axis="y" onDrag={onDrag} onStop={onStop}>
        <div
          style={{
            backgroundColor: "#0E30E0",
            boxShadow: "rgb(0 0 0 / 15%) 0px 1px 3px 1px ",
            color: "white",
            fontSize: "1.5em",
            height: "60px ",
            margin: "0px ",
            position: "fixed ",
            bottom: "270px ",
            zIndex: "1500",
            direction: language === "english" ? "rtl" : "ltr",
            right: language === "english" ? "0px" : "",
            left: language === "english" ? "" : "0px",
            width: "40px",
            borderRadius:
              language === "english" ? "5px 0px 0px 5px" : "0px 5px 5px 0px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            {showChat && (
              <>
                <Iframe
                  url={`https://ebchat-saas.e-butler.com/web-guest/?companyID=${ebutler_company_id}&language=${
                    language === "english" ? "en" : "ar"
                  }`}
                  height={ios ? "350px" : "400px"}
                  frameBorder="0"
                  className={` _2iWL7 _1fOYS ${ios ? "e-bulter-bottom" : ""}`}
                  styles={{
                    zIndex: "1500",
                    display: hideChat ? "block" : "none",
                    left: language === "english" ? "" : "0px",
                    overflowX: "hidden",
                  }}
                />
              </>
            )}
          </div>
          <EbutlerIcon
            style={{
              width: "80%",
              height: "auto",
              color: "white",
            }}
          />
        </div>
      </Draggable>
    </>
  ) : null;
};

export default EbutlerWidget;
